export default {
    gifSrc: 'gif-banner-app.gif',
    gifAlt: 'Baixe o app do Astrolink',
    playStoreBadge: 'cta-google-play.png',
    appleStoreBadge: 'apple-store-br.png',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.astrolink.webapp',
    appleStoreUrl: 'https://apps.apple.com/br/app/astrolink/id1598327566',
};
